const sideMenu = [
  {
    id: "dashboard",
    label: "Dashboard",
    href: "/app/dashboard",
    permissions: [1]
  },
  {
    id: "employee_dashboard",
    label: "Employee Dashboard",
    href: "/app/employee-dashboard",
    permissions: [2]
  },
  {
    id: "contract_list",
    label: "Contracts",
    href: "/app/contract",
    permissions: [1]
  },
  {
    id: "template_management",
    label: "Template Management",
    href: "/app/contract/template-management",
    permissions: [1]
  },
  {
    id: "userlist",
    label: "User Management",
    href: "/app/users",
    permissions: [1]
  }
];

export default sideMenu;
